$ {
  const {
    model
  } = input;
  const componentName = 'variation-selector';
}
<if(model)>
   
  $ const {
    traits,
    variations
  } = model;
  <if(traits)>
    <div class=[componentName] key=componentName data-testid=componentName>
      <for|trait| of=traits>
        <trait-selector trait=trait selectedValue=component.getSelectedValue(trait.name) selectedTraits=state.selectedTraits variations=variations error=state.error on-traitChange("handleTraitChange")/>
      </for>
    </div>
  </if>
</if>